module.exports = __webpack_public_path__ + "img/green.7a9835ea.png";